// extracted by mini-css-extract-plugin
export default {"tabButton":"tab-button_tabButton__tDztY","inActive":"tab-button_inActive__7Rve3","active":"tab-button_active__n7x8I"};